var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilterEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 43317"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 106",
    cx: 7,
    cy: 7,
    r: 7,
    fill: "#3A3A3A"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 43314"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.5 6.61111V8.94444C10.5 9.80354 9.80354 10.5 8.94444 10.5H5.05556C4.19645 10.5 3.5 9.80354 3.5 8.94444V5.05556C3.5 4.19645 4.19645 3.5 5.05556 3.5H7.38889",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M9.30295 3.70533C9.43439 3.57386 9.61274 3.5 9.79862 3.5C9.98455 3.5 10.1629 3.57386 10.2943 3.70533C10.4258 3.8368 10.4997 4.01511 10.4997 4.20103C10.4997 4.38696 10.4258 4.56527 10.2943 4.69674L7.15488 7.83619L5.83301 8.16667L6.16348 6.84479L9.30295 3.70533Z",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M8.55566 4.66699L9.33344 5.44477",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterEditIcon);
export default __webpack_public_path__ + "static/media/FilterEditIcon.97bce73dc429783a7abc167dee29d7bb.svg";
export { ForwardRef as ReactComponent };